import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import ServiceHome from "./ServiceHome";
import Artwork from "./Artwork";
import Embroidery from "./Embroidery";
import Namedrop from "./Namedrop";
import PrintDesign from "./PrintDesign";
import bannerImg from "../../asset/homefour/services.webp";

const HEADER_OFFSET = 120;

const Service = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);

      if (el) {
        // 🔥 wait till layout settles
        setTimeout(() => {
          const y =
            el.getBoundingClientRect().top +
            window.pageYOffset -
            HEADER_OFFSET;

          window.scrollTo({
            top: y,
            behavior: "smooth",
          });
        }, 200);
      }
    }
  }, [location]);

  return (
    <div>
      <Breadcrumb bannerImage={bannerImg} currentPage="Services" />
      <ServiceHome />

      <div id="artwork">
        <Artwork />
      </div>

      <div id="digitizing">
        <Embroidery />
      </div>

      <div id="namedrop">
        <Namedrop />
      </div>

      <div id="print-design">
        <PrintDesign />
      </div>
    </div>
  );
};

export default Service;
